import { render, staticRenderFns } from "./HeadedSpanList.vue?vue&type=template&id=113700db&scoped=true&"
import script from "./HeadedSpanList.vue?vue&type=script&lang=js&"
export * from "./HeadedSpanList.vue?vue&type=script&lang=js&"
import style0 from "./HeadedSpanList.vue?vue&type=style&index=0&id=113700db&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113700db",
  null
  
)

export default component.exports